<template>
  <div class="content pr-2">
    <h1 class="has-text-centered">
      Join our mailing list!
    </h1>
    <hr>
    <div ref="cctInlineForm" class="ctct-inline-form" data-form-id="7c88c618-ad26-4609-afeb-18362b3a70ea"></div>
  </div>
</template>

<script>
export default {
  name: 'subscribe',
  metaInfo: {
    title: 'AHL Poker :: Join our mailing list!'
  },
  data () {
    return {}
  },
  mounted() {
    window.SignUpFormWidget.main()
  },
  computed: {},
  methods: {}
}
</script>